import { render, staticRenderFns } from "./PaymentRedirect.vue?vue&type=template&id=9354589a&"
import script from "./PaymentRedirect.vue?vue&type=script&lang=js&"
export * from "./PaymentRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports